export default "/images/rent-home-icon.svg?c4e7c37651ca674ce8944e3ce1e20ac4";